import { useState, memo } from 'react';
import { Box } from '@mui/material';
import smallYellowStarsIcon from 'images/icons/generativeAi/yellow_stars_16x16.gif';
import { TicketSummaryTooltip } from 'common/components/summaryPopup/Tooltip';
import { useApplicationData } from 'remote-state/applicationHooks';
import { QUERIES_KEYS } from 'constant';
import { IdFieldWrapperStyled } from './styles';

const IdFieldRender = memo(({ srId }) => {
  const { data: isAiEnabled } = useApplicationData(QUERIES_KEYS.IS_AI_ENABLED);
  const [isIdhovered, setIsIdHovered] = useState(false);
  const isShowAiIcon = isIdhovered && isAiEnabled;

  return (
    <Box data-testid={`ticket-id-${srId}`}>
      <TicketSummaryTooltip>
        <IdFieldWrapperStyled onMouseEnter={() => setIsIdHovered(true)} onMouseLeave={() => setIsIdHovered(false)}>
          <div className="rowIDelem" sysaid-cell-id={srId}>
            {srId}
          </div>
          <img src={smallYellowStarsIcon} alt="" style={{ visibility: isShowAiIcon ? 'visible' : 'hidden' }} />
        </IdFieldWrapperStyled>
      </TicketSummaryTooltip>
    </Box>
  );
});

export default IdFieldRender;
